module.exports = __webpack_public_path__ + "static/media/onboarding.84331007.svg";